module.exports = __webpack_public_path__ + "media/components/util/logos/eezy-logo--white-8ce98aad345a205d99918a07ccb94658.svg";